import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GetService } from '../../core/get.service';
import { AuthService } from '../auth.service';
import { AppMemoryService } from '../../core/app-memory.service';
import { environment } from '../../../environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { AuthLoginResponse } from '../../models/LoginInterface';
import { saRegionSc, saRegionSc24 } from '../../models/Regions';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.less']
})

export class LoginComponent implements OnInit {
  public languages = environment.languages || [];

  public serverError = null;
  public blockErrorMessage = {
    title: '',
    message: ''
  };
  public isRequestInProgress = false;

  public login = {
    email: '' as string,
    password: '' as string
  };

  public selectedLang = environment.defaultLanguage;
  public invoiceLink = '';

  constructor(
    public router: Router,
    public authService: AuthService,
    public appMemory: AppMemoryService,
    public getService: GetService,
    public translate: TranslateService
  ) {
    if (!this.authService.isLocated) {
      this.router.navigateByUrl('/locate');
    }
  }

  ifLoged() {
    localStorage.setItem('isConfirm', 'true');
    this.authService.isConfirm = true;
    $('body').removeClass('modal-open');
    this.router.navigate(['/horses'], {});
    return;
  }

  cancelLogin() {
    this.authService.logout();
    $('body').removeClass('modal-open');
    $('#checkCountry').removeClass('open');
  }

  setLanguage(lang: string) {
    this.translate.use(lang);
    this.selectedLang = lang;
  }

  sendLogin(form: any): void {
    if (form.form.invalid) {
      return;
    }

    this.isRequestInProgress = true;
    this.getService.logIn(this.login.email, this.login.password, this.selectedLang).then((res: AuthLoginResponse) => {
      this.authService.login(res.access_token);
      if (this.authService.isConfirm) {
        this.translate.use(res.user.language && res.user.language.match(/en|en-US|fr|sa/) ? res.user.language : (environment.defaultLanguage || 'en'));
        localStorage.setItem('equineLang', res.user.language);
        if (!localStorage.getItem('showTutorial')) {
          localStorage.setItem('showTutorial', 'true');
          this.getService.setShowTutorial(true);
        }
        this.router.navigate(['/horses'], {});
      } else {
        $('body').addClass('modal-open');
        $('#checkCountry').fadeIn(400).addClass('open');
      }
      this.isRequestInProgress = false;
      this.displayPopupInfo(res.farmRegions);
    }, (err: any) => {
      this.isRequestInProgress = false;
      const error = JSON.parse(err._body);
      if (err.status === 402) {
        this.invoiceLink = error.error.invoice_link || '';
        this.blockErrorMessage = error.error;
        $('#blocked-warning').fadeIn(400).addClass('open');
      } else {
        this.serverError = this.objectToArray(error);
      }
    });
  }

  displayPopupInfo(regions: string[]) {
    if (regions.includes(saRegionSc24)) {
      $('#popup-info').addClass('open').css('display: block');
    }
  }

  objectToArray(obj: Object) {
    return Object.keys(obj).map(key => obj[key]); // transform Array-like Object to Array
  }

  ngOnInit(): void {
    setTimeout(() => {
      $('.modal.open').removeClass('open');
      $('body').removeClass('modal-open');
      const $Input = $('input:-webkit-autofill');
      $Input.next('label').addClass('active');
    }, 0);
  }

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/app/auth/login/login.component.ts